/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const UploadToCloudIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Upload To Cloud',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m19.73877,11.66797c0,1.15771-.45068,2.24561-1.26904,3.06348s-1.90625,1.26855-3.06348,1.26855h-.65723c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h.65723c.75635,0,1.46777-.29443,2.00293-.82959.53516-.53467.82959-1.24561.82959-2.00244,0-.72754-.27686-1.41748-.7793-1.94189-.50146-.52393-1.17676-.8335-1.90234-.87207-.25439-.01367-.48486-.15576-.61133-.37695-.12646-.22168-.13184-.49219-.01367-.71826.12549-.24121.22217-.48975.28711-.73877.06836-.25977.10303-.52588.10303-.7915,0-.89355-.34766-1.7334-.979-2.36523-1.20801-1.20703-3.29639-1.27393-4.56787-.14062-.60059.53662-.98975,1.27246-1.09424,2.07275-.03076.23584-.17188.44336-.37988.55859-.20752.11572-.45752.12549-.6748.02686-.16846-.07666-.3418-.13574-.5166-.17529-.86035-.1958-1.7417.06934-2.34863.66211-.47461.46289-.73584,1.07666-.73584,1.72803,0,.16748.01807.33496.05322.49854.03467.1582.08643.31543.15283.46582.09961.22412.08301.48291-.04395.69287-.12744.20996-.34912.34424-.59375.35986-.49609.03174-.95654.24707-1.29785.60596-.34131.36035-.52979.83252-.52979,1.32959,0,.52148.20312,1.01172.57178,1.38037.36865.36816.8584.57129,1.37988.57129h2.09961c.41406,0,.75.33594.75.75s-.33594.75-.75.75h-2.09961c-.92188,0-1.78857-.35889-2.44043-1.01074-.65234-.65186-1.01123-1.51904-1.01123-2.44092,0-.88281.33447-1.72119.94141-2.36182.38721-.40771.86084-.71045,1.38232-.88965-.04297-.23145-.06445-.46631-.06445-.70117,0-1.05908.42188-2.0542,1.18848-2.80176.95605-.93408,2.3335-1.3501,3.67627-1.0625.26416-.81494.74072-1.55127,1.38672-2.12793.88184-.78613,2.01855-1.21924,3.20166-1.21924,1.29346,0,2.51025.50391,3.42529,1.41846.91455.91504,1.41846,2.13184,1.41846,3.42578,0,.39453-.05127.78906-.15234,1.17236-.01074.04199-.02246.08398-.03467.12549.72119.21191,1.37793.60889,1.90771,1.16211.771.80518,1.1958,1.86328,1.1958,2.97949Z"
      fill="currentColor"
    />
    <path
      d="m13.85352,10.82373l-3.00293-2.99756c-.29297-.29199-.76709-.29248-1.06006.00049l-2.99707,2.99756c-.29297.29297-.29297.76758,0,1.06055.14648.14648.33838.21973.53027.21973s.38379-.07324.53027-.21973l1.72217-1.72253v8.18347c0,.41406.33594.75.75.75s.75-.33594.75-.75v-8.17517l1.71777,1.71472c.29248.29199.76709.29199,1.06055-.00098.29248-.29297.29248-.76807-.00098-1.06055Z"
      fill="currentColor"
    />
  </svg>`;
};
